import { normalize, Schema, arrayOf } from 'normalizr'
import { stringify } from 'query-string'
import lscache from 'lscache'

import { logout } from '../redux/auth'
import { API_PATH, ENDPOINT_PICASSO } from '../constants'

export function fetch (endpoint, { method = 'get', query = {}, body, token, schema, cache, cacheKey } = {}, dispatch) {
  const querystring = query ? '?' + stringify(query) : ''
  const options = {
    method,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  }
  if (body) {
    options.body = JSON.stringify(body)
  }
  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`
  }
  const url = API_PATH + endpoint + querystring
  const cached = lscache.get(cacheKey || url)
  if (cache && cached) {
    return Promise.resolve(cached)
  }
  return window.fetch(url, options)
    .then(response => checkStatusCode(response, dispatch))
    .then(parseJSON)
    .then(json => {
      const result = schema ? normalize(json, schema) : json
      if (cache) {
        lscache.set(cacheKey || url, result, cache)
      }
      return result
    })
}

export function picassoFetch (auth, action, body, dispatch) {
  return fetch(ENDPOINT_PICASSO, {
    method: 'post',
    token: auth.token,
    body: { action, ...body }
  }, dispatch)
}

function checkStatusCode (response, dispatch) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    if (dispatch && response.status === 401) {
      dispatch(logout())
    }
    const { status, statusText } = response
    return response.json().then(data => {
      const error = {
        status,
        statusText,
        message: data && (data.message || data.error)
      }
      throw error
    })
  }
}

function parseJSON (response) {
  if (response.status === 204) {
    return null
  }
  return response.json()
}

const node = new Schema('graph', { idAttribute: '_id' })
node.define({
  children: arrayOf(node)
})

export const schemas = {
  album: new Schema('albums'),
  playlist: new Schema('playlists'),
  queue: new Schema('queues'),
  image: new Schema('images', { idAttribute: '_id' }),
  user: new Schema('users'),
  graph: arrayOf(node)
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js